<template>
	<div>
		<v-progress-linear
			indeterminate
			color="primary"
			height="3"
			v-show="loadingData"
		></v-progress-linear>
		<v-card>
			<v-data-table
				class="table"
				:items="onSitePurchases"
				:items-per-page="100"
				:headers="headers"
				hide-default-footer
				fix-header
				item-key="id"
				no-data-text="There is no data to this filters."
				:options.sync="options"
			>
				<template v-slot:item.price_incl_tax="{ item }">
					{{ item.price_incl_tax | currency(currencyFormat) }}
				</template>
			</v-data-table>
			<v-flex class="pagination">
				<v-progress-linear
					indeterminate
					color="primary"
					height="3"
					v-show="loadingData"
				></v-progress-linear>
				<v-pagination
					:key="paginationKey"
					v-model="pagination.page"
					:length="pagination.pages"
					@input="next"
					v-show="pagination.showBottomPagination"
					:total-visible="pagination.totalVisible"
					circle
				></v-pagination>
			</v-flex>
		</v-card>
	</div>
</template>

<script>
export default {
	name: 'OnSitePurchasesTable',
	props: [
		'onSitePurchases',
		'selectedFilters',
		'pagination',
		'currencyFormat',
		'loadingData',
		'paginationKey',
	],
	filters: {
		currency(value, currencyFormat) {
			if (value === null || value === undefined) return ''
			return new Intl.NumberFormat(currencyFormat.locale, {
				style: 'currency',
				currency: currencyFormat.currency,
			}).format(value)
		},
	},
	data() {
		return {
			headers: [
				{ text: 'Order date', value: 'created_at', sortable: true },
				{ text: 'Reservation ID', value: 'reservation_id', sortable: true },
				{ text: 'Serviceprovider', value: 'serviceprovider_name', sortable: true },
				{ text: 'SKU', value: 'sku', sortable: true },
				{ text: 'Product name', value: 'product_name', sortable: true },
				{
					text: 'Price incl. tax', value: 'price_incl_tax', sortable: true, align: 'right',
				},
				{ text: 'Ticket type', value: 'ticket_type_name', sortable: true },
				{ text: 'Consumer group', value: 'consumer_group_name', sortable: true },
				{ text: 'Firstname', value: 'firstname', sortable: true },
				{ text: 'Lastname', value: 'lastname', sortable: true },
				{ text: 'Reservation date', value: 'reservation_date', sortable: true },
				{ text: 'Validity end date', value: 'validity_end_date', sortable: true },
				{ text: 'Guestcard', value: 'guestcard_name', sortable: true },
			],
			options: {
				page: 1,
				itemsPerPage: 50,
				sortBy: ['created_at'],
				sortDesc: [true],
				groupBy: [],
				groupDesc: [],
				mustSort: false,
				multiSort: false,
			},
		}
	},
	watch: {
		options: {
			handler() {
				const selectedFiltersAndPagination = {
					filterOptions: this.selectedFilters,
					pagination: this.pagination,
				}
				selectedFiltersAndPagination.pagination.sortBy = this.options.sortBy
				selectedFiltersAndPagination.pagination.sortDesc = this.options.sortDesc
				this.$emit('sortHasChanged', selectedFiltersAndPagination)
			},
		},
	},
	methods: {
		next() {
			const selectedFiltersAndPagination = {
				filterData: this.selectedFilters,
				pagination: this.pagination,
			}
			this.$emit('next', selectedFiltersAndPagination)
		},
	},
}
</script>

<style scoped>
.pagination {
	text-align: center;
}
</style>
